import { render, staticRenderFns } from "./CollaboratorCreateUpdate.vue?vue&type=template&id=2c0ede5a&scoped=true&"
import script from "./CollaboratorCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./CollaboratorCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./CollaboratorCreateUpdate.vue?vue&type=style&index=0&id=2c0ede5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0ede5a",
  null
  
)

export default component.exports